import React, { useEffect } from 'react';
import AOS from 'aos';

import Header from '../../components/Header';
import Footer from '../../components/Footer';

import './../../assets/styles/globals.css';
import "aos/dist/aos.css";
import './styles.css';

import videoBackground from '../../assets/video/timeline.mp4';

function About() {

  useEffect(() => {
    AOS.init()
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }, [])

  return (
    <>
      <Header />
      <div className="background-about-us">
        <div className="bg-about-us"></div>
        <div className="container">
          <div className="banner-about-us content-about-us">
            <h1>About Us</h1>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="content gap section-title" data-aos-once="true" data-aos="fade-up" data-aos-delay="100" data-aos-duration="1500">
          <h1>Eólica Tecnologia</h1>
          <p className="bio-text">
            Eólica Technology Ltda is one of the leading companies in wind farm development and operation in Brazil. <br /> A company that develops, constructs, operates and manages renewable energy projects, playing an active role in all wind energy sectors.<br /> <br />
            The company counts with the expertise of its President Everaldo Alencar Feitosa, Ph.D (Southampton University, UK). A renowned advisor to several institutions legislation of renewable energy, former president of the Brazilian Wind Energy Center (CBEE) and vice president of the World Wind Energy Association (www.wwindea.org). 
            A pioneer in wind energy development, he was responsible for the implementation of the very first wind turbine in the country in 1992, as well as the largest hybrid wind-diesel system in the Americas. <br /> <br />
            Excellence in projects - a unique value of <b>Eólica Tecnologia</b>. Acting in Brazil since 2000.
          </p>
        </div>
      </div>


      <div className="container">
        <div className="content section-title video-title">
          <h1>Our History</h1>
          <div className="video-container">
            <video controls autoPlay muted loop id="history-video" playsInline >
              <source src={videoBackground} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default About;